import React from "react"
import "../styles/layout.css"

const Banner = ({ title, description, backgroundCSS }) => (
        <div className={"banner " + backgroundCSS }>
            <div className="page-info section-container">
                <div className="info">
                    <h1
                        data-sal="slide-up"
                        data-sal-duration="1000"
                        data-sal-easing="ease"
                        >
                        {title}</h1>
                    <h3
                        data-sal="slide-up"
                        data-sal-duration="1000"
                        data-sal-delay="400"
                        data-sal-easing="ease"
                        >
                        {description} </h3>
                </div>
            </div>
        </div>
)

export default Banner

